import { ACTIVATION, VISUALIZATION } from "@/consts/widget";

import * as types from "./mutationTypes";

export default {
  [types.CLEAR_WIDGETS](state) {
    state.widgets = null;
  },
  [types.CLEAR_WIDGET](state) {
    state.widget = {};
  },
  [types.SET_WIDGET]: (state, widget) => {
    if (widget) {
      widget.hosts = widget.hosts || [];
      if (widget.responses > 0 || widget.start_date || widget.end_date) {
        widget.activation = ACTIVATION.AUTO;
        if (widget.responses > 0) {
          widget.deactivateByResponses = true;
        } else {
          widget.deactivateByResponses = false;
        }
        if (widget.start_date || widget.end_date) {
          widget.deactivateByDate = true;
        } else {
          widget.deactivateByDate = false;
        }
      } else {
        widget.activation = ACTIVATION.MANUAL;
        widget.deactivateByResponses = false;
        widget.deactivateByDate = false;
      }
      if (widget.delay) {
        widget.visualization = VISUALIZATION.TIMEOUT;
      } else {
        widget.visualization = VISUALIZATION.IMMEDIATE;
      }
    }
    state.widget = { ...widget };
  },
  [types.SET_WIDGETS](state, widgets) {
    state.widgets = widgets;
  },
  [types.SET_ENABLED](state, isEnabled) {
    state.widget.enabled = isEnabled;
  },
  [types.SET_NAME](state, value) {
    state.widget.name = value;
  },
  [types.SET_HOSTS](state, hosts) {
    state.widget.hosts = hosts;
  },
  [types.SET_HOST_PATH](state, { value, index }) {
    state.widget.hosts[index].host_name = value;
  },
  [types.SET_HOST_SURVEY](state, { value, index }) {
    state.widget.hosts[index].survey_uuid = value;
  },
  [types.ADD_HOST](state) {
    state.widget.hosts = state.widget.hosts.concat({
      host_name: "",
      survey_uuid: ""
    });
  },
  [types.REMOVE_HOST](state, index) {
    state.widget.hosts = state.widget.hosts.filter((u, i) => i !== index);
  },
  [types.SET_MANUAL](state) {
    state.widget.responses = 0;
    state.widget.start_date = null;
    state.widget.end_date = null;
  },
  [types.SET_ACTIVATION](state, value) {
    state.widget.activation = value;
  },
  [types.SET_DEACTIVATION_RESPONSES](state, value) {
    state.widget.deactivateByResponses = value;
  },
  [types.SET_DEACTIVATION_DATE](state, value) {
    state.widget.deactivateByDate = value;
  },
  [types.SET_RESPONSES](state, responses) {
    state.widget.responses = responses;
  },
  [types.SET_START_DATE](state, date) {
    state.widget.start_date = date;
  },
  [types.SET_END_DATE](state, date) {
    state.widget.end_date = date;
  },
  [types.SET_VISUALIZATION](state, value) {
    state.widget.visualization = value;
  },
  [types.SET_DELAY](state, value) {
    state.widget.delay = value;
  },
  [types.SET_RECURRENCE](state, value) {
    state.widget.show_widget = value;
  },
  [types.SET_RECURRENCE_DAYS_RESPONDED](state, value) {
    state.widget.days_after_response = Number(value);
  },
  [types.SET_RECURRENCE_DAYS_REFUSED](state, value) {
    state.widget.days_after_decline = Number(value);
  },
  [types.SET_EXHIBITION](state, value) {
    state.widget.exhibition = value;
  },
  [types.SET_MINIMIZED](state, value) {
    state.widget.minimized = value;
  },
  [types.SET_SURVEY_COLOR](state, value) {
    state.widget.survey_colors = value;
  },
  [types.SET_PRIMARY_COLOR](state, value) {
    state.widget.primary_color = value;
  },
  [types.SET_SECONDARY_COLOR](state, value) {
    state.widget.secondary_color = value;
  },
  [types.SET_THANKS_MESSAGE](state, { language, value }) {
    state.widget.thanks_message[language] = value;
  },
  [types.SET_SURVEY](state, survey) {
    state.widget.survey = { ...survey };
  }
};
